import { PlainTooltip } from "@similarweb/ui-components";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { memo } from "react";
import type { SelectionDropdownItem } from "../../models/selection-dropdown-item/types";
import { StyledDropdownItem, StyledDropdownItemText } from "./styles";

type SelectionDDItemProps = {
    item: SelectionDropdownItem;
    isSelected: boolean;
    onClick?(item: SelectionDropdownItem): void;
};

function SelectionDDItem(props: SelectionDDItemProps) {
    const { item, isSelected, onClick } = props;
    const isDisabled = typeof item.disabledReason !== "undefined";
    const translation = item.getTranslation();

    const renderedItem = (
        <StyledDropdownItem
            isSelected={isSelected}
            isDisabled={isDisabled}
            onClick={handleClick}
            data-automation="selection-dropdown-item"
            data-automation-id={item.id}
            data-automation-disabled={isDisabled}
            data-automation-selected={isSelected}
        >
            <I18n
                data-automation="selection-dropdown-item.text"
                element={StyledDropdownItemText}
                translatable={translation}
            />
        </StyledDropdownItem>
    );

    function handleClick() {
        if (isDisabled) {
            return;
        }

        onClick?.(item);
    }

    if (isDisabled) {
        return (
            <PlainTooltip tooltipContent={<I18n translatable={item.disabledReason} />}>
                <div>{renderedItem}</div>
            </PlainTooltip>
        );
    }

    return renderedItem;
}

export default memo(SelectionDDItem);
